import React from 'react'
import { firstCharCapitalize } from '../utils/utils'
import './ProductoExpositorLinea.scss'
// import Fab from '@material-ui/core/Fab';
// import AddIcon from '@material-ui/icons/Add';
// import RemoveIcon from '@material-ui/icons/Remove';

export const ProductoExpositorLinea = ({ product }) => {
    return (
        <div className="producto-expositor-linea">
            <div className="img-product">
                <div className="img">
                    <img src={"/static/imgProducts/" + product.product.Fotografia + "_p.jpg"} onError={(e) => {
                        e.target.onerror = null
                        e.target.src = '/static/img/no-imagen-fansa.png'
                    }} alt="" />
                </div>
                <div className="producto item">
                    <div className="titulo"><p>PRODUCTO</p></div>
                    <div className="subtitulo pointer"><p>{firstCharCapitalize(product.product.Descripcion)}</p></div>
                </div>
            </div>
            <div className="unidades item">
              <div>
                <div className="titulo"><p>UNIDADES</p></div>
                <div className="subtitulo"><p>{product.quantity} un</p></div>
              </div>
            </div>
        </div>
    )
}